import CustomTable from 'components/CustomTable';
import TextHeader from 'components/CustomText/TextHeader';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components/macro';
import LoadingIndicator from 'components/LoadingIndicator';
import { Grid } from '@material-ui/core';
import api from 'api/call';
import { getTimeWithTimeZone } from 'utility/general';
import { reviewResultDecision } from 'utility/postApprovalLookUp';
import { useSelector } from 'react-redux';
import { IRB, SECRETARY } from 'utility/lookup';

const SLayout = styled.div`
    padding: 10px;
`;

const ReviewerComment = ({ formId, documentType }) => {
    const userRole = useSelector((state) => state.user.role);

    const columns = [
        {
            field: 'createdDtm',
            headerName: 'Date',
            width: 150,
            valueGetter: (params) => {
                return params.row.createDtm
                    ? getTimeWithTimeZone(params.row.createDtm).format('YYYY-MM-DD HH:mm')
                    : '-';
            },
        },
        {
            field: 'name',
            headerName: 'Name',
            width: 150,
        },
        {
            field: 'comment',
            headerName: 'Comment',
            width: 400,
        },
        {
            field: 'decision',
            headerName: 'Decision',
            width: 150,
            valueGetter: (params) => {
                return reviewResultDecision.filter((item) => item.key === params.row.decision)[0]?.display;
            },
        },
    ];

    // make sure only IRB / Secretary can see the following column
    if (userRole === IRB || userRole === SECRETARY) {
        columns.push({
            field: 'willShareComment',
            headerName: 'Willing to share comment / decision?',
            width: 150,
        });

        columns.push({
            field: 'conflictOfInterest',
            headerName: 'Conflict of interest?',
            width: 150,
        });
        
        columns.push({
            field: 'relationships',
            headerName: 'Relationship',
            width: 250,
        });
    }

    const [rows, setRows] = useState([]);

    const [isLoading, setLoading] = useState(true);

    useEffect(() => {
        api.reviewer
            .getReviewerComment({
                sort: 'createDtm',
                isDesc: true,
                documentId: formId,
                documentTypeId: documentType,
            })
            .then((res) => {
                setRows(res.data.result);
            })
            .finally(() => {
                setLoading(false);
            });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <SLayout>
            <TextHeader underline>Reviewer Comment</TextHeader>

            <div style={{ marginTop: 20 }}>
                {isLoading ? (
                    <Grid container alignItems="center" justify="center" style={{ height: '100px' }}>
                        <LoadingIndicator /> <div style={{ marginLeft: 10 }}>Loading Comments...</div>
                    </Grid>
                ) : (
                    <CustomTable
                        skipMaxHeight
                        fullWidthTable={false}
                        showAlternativeBackground
                        rows={rows}
                        columns={columns}
                    />
                )}
            </div>
        </SLayout>
    );
};

export default ReviewerComment;
